import {Button} from "@mui/material"
import Grid from "@mui/material/Grid"
import {paletteColors} from "@indebted/theme"
import {useTranslation} from "react-i18next"
import {useNavigate} from "react-router-dom"
import {paymentArrangementAPI} from "@indebted/api/paymentArrangementAPI"
import {useMutation} from "@tanstack/react-query"
import {ApiError} from "@indebted/api/ApiError"
import {useNotification} from "@indebted/components/Notification"

import {nextPage} from "../Navigator"
import {usePaymentArrangementId} from "../usePaymentArrangementId"

import {ColoredTypographyWithBottomMargin, BulletList, GridWithPadding} from "./styles"

const UpdatePaymentArrangement = () => {
	const navigate = useNavigate()
	const paymentArrangementID = usePaymentArrangementId()
	const {t} = useTranslation()
	const {notification} = useNotification()

	const cancelPaymentArrangement = useMutation({
		mutationFn: () => paymentArrangementAPI.cancel(paymentArrangementID),
		onSuccess: () => {
			navigate(`../status`)
		},
		onError: (error) => {
			if (error instanceof ApiError) {
				notification.error(error.Message, 5000)
			} else {
				notification.error(t("unexpected_error.message"), 5000)
			}
			console.error(error)
		},
	})

	return (
		<GridWithPadding container direction="column" alignItems="center" justifyContent="center">
			<Grid
				container
				direction="row"
				alignItems="flex-start"
				justifyContent="flex-start"
				style={{marginBottom: "16px", marginTop: "20px", marginLeft: "-4px"}}
			>
				<ColoredTypographyWithBottomMargin
					variant="h5"
					color={paletteColors.stratos}
					align="left"
					style={{fontWeight: 600, fontSize: "18px", lineHeight: "22px", paddingLeft: "0px"}}
				>
					{t("payment_arrangement_update.title")}
				</ColoredTypographyWithBottomMargin>
			</Grid>
			<Grid
				container
				direction="row"
				alignItems="flex-start"
				justifyContent="flex-start"
				style={{marginBottom: "10px"}}
			>
				<ColoredTypographyWithBottomMargin
					variant="subtitle1"
					color={paletteColors.stratos}
					align="left"
					style={{fontSize: "14px", lineHeight: "20px"}}
				>
					{t("payment_arrangement_update.subtitle")}
				</ColoredTypographyWithBottomMargin>
				<br />

				<BulletList color={paletteColors.stratos}>
					<li>{t("payment_arrangement_update.bullet_point_one")}</li>
					<li>{t("payment_arrangement_update.bullet_point_two")}</li>
					<li>{t("payment_arrangement_update.bullet_point_three")}</li>
				</BulletList>
			</Grid>

			<Grid
				container
				direction="row"
				alignItems="center"
				justifyContent="center"
				style={{marginBottom: "34px", width: "100%"}}
			>
				<Button
					style={{
						borderRadius: "4px",
						padding: "6px 16px",
						width: "100%",
						backgroundColor: paletteColors.warningButtonRed,
					}}
					type="button"
					disabled={cancelPaymentArrangement.isPending}
					onClick={() => cancelPaymentArrangement.mutate()}
					variant="contained"
				>
					{t("payment_arrangement_update.continue_button_label")}
				</Button>
				<Button
					style={{borderRadius: "35px", padding: "6px 30px", marginTop: "10px"}}
					type="button"
					onClick={() => {
						navigate(nextPage("manage", paymentArrangementID))
						navigate(0)
					}}
					variant="text"
				>
					{t("payment_arrangement_update.back_button_label")}
				</Button>
			</Grid>
		</GridWithPadding>
	)
}

export {UpdatePaymentArrangement}
